import API from 'services/API';

export default function getPercentDeposits() {
  return API.request({
    method: 'GET',
    url: '/taxpayer/percentDeposits',
  });
}
